/**
 * "New message" around the shell (Slack's ⌘N, the sidebar's Direct messages "+" and "More conversations…", "Add people"
 * on a DM): one sheet per workspace (AppShell owns whether it is open), reached through @bundle/ui NewMessageContext.
 */
import { Shell, type OpenTarget } from "@bundle/core";
import { NewMessageSheet, useNewMessage, useWorkspace } from "@bundle/ui";

export function NewMessageChrome(p: { open: boolean; onClose: () => void; navigate: (url: string, target?: OpenTarget) => void }) {
  const ws = useWorkspace();
  const nm = useNewMessage();
  return (
    <NewMessageSheet
      open={p.open}
      onClose={p.onClose}
      vm={nm.vm}
      state={nm.state}
      online={ws.state.network}
      onOpenConversation={(channelId) => {
        p.onClose();
        p.navigate(Shell.formatUrl({ type: "channel", ws: ws.slug, channelId }));
      }}
    />
  );
}
